import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TestPlanPackage, TestPlanPackageRequest } from '../models/test-plan-package.model';
import { CreatedTestRun } from '../models/test-run.model';

@Injectable({ providedIn: 'root' })
export class TestPlanPackageService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  /** Pakete des Plans, sortiert nach Position. */
  list(projectId: string, planId: string): Observable<TestPlanPackage[]> {
    return this.http.get<TestPlanPackage[]>(this.url(projectId, planId));
  }

  /** Ersetzt alle Pakete des Plans; nicht gesendete Pakete löscht das Backend. */
  replace(projectId: string, planId: string, body: TestPlanPackageRequest[]): Observable<TestPlanPackage[]> {
    return this.http.put<TestPlanPackage[]>(this.url(projectId, planId), body);
  }

  /** Startet je Umgebung des gespeicherten Pakets einen Probelauf `PR-…`. */
  startTrial(projectId: string, planId: string, packageId: string): Observable<CreatedTestRun[]> {
    return this.http.post<CreatedTestRun[]>(`${this.url(projectId, planId)}/${packageId}/trial-runs`, null);
  }

  private url(projectId: string, planId: string): string {
    return `${this.base}/${projectId}/test-plans/${planId}/packages`;
  }
}
